import React, { forwardRef } from 'react';

import { ClientTransforms } from 'src/editor/transforms';
import { useCurrentUserId } from 'src/gql';
import { useAuthorizedTransforms } from 'src/hooks';
import { useEditor } from 'src/layout-engine';
import { useEditingMode } from 'src/store/document/selectors';

import { BaseMenuOption } from '../BaseMenuOption';
import type { CommonMenuItemProps } from '../types';

export const UpdateCrossReferencesMenuItem = forwardRef(function UpdateCrossReferencesMenuItem(
  props: CommonMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element | null {
  const { closeRootMenu, ...rest } = props;
  const editor = useEditor();
  const currentUserId = useCurrentUserId();
  const { editingMode } = useEditingMode();
  const { AuthorizedTransforms } = useAuthorizedTransforms();

  function updateCrossReferences(): void {
    if (!editingMode || !currentUserId) return closeRootMenu();

    AuthorizedTransforms.updateAllCrossReferences(editor, {
      authorId: currentUserId,
      editingMode,
    });
    ClientTransforms.focus(editor);
    closeRootMenu();
  }

  return (
    <BaseMenuOption ref={ref} label="Update references" onClick={updateCrossReferences} {...rest} />
  );
});
